import { Text, Flex, useTheme } from '@vitvio/design-system';
import { UpdateTimeInput } from './../timer-content/UpdateTimeInput';
import { graphql, useFragment } from 'react-relay';
import type { TimerContentUpdateInputFragment$key } from './__generated__/TimerContentUpdateInputFragment.graphql';
const fragment = graphql`
  fragment TimerContentUpdateInputFragment on Job {
    id
    status
    template {
      category
    }
  }
`;

interface Props {
  fragmentRef: TimerContentUpdateInputFragment$key | undefined;
}

export function TimerContentUpdateInput({ fragmentRef }: Props) {
  const data = useFragment(fragment, fragmentRef);
  const { getColor } = useTheme();
  const status = data?.status;
  const jobId = data?.id;
  const category = data?.template?.category;

  if (category !== 'SURGERY') {
    return null;
  }

  if (status === 'RUNNING') {
    return (
      <Flex flexDir={'column'} gap={'16px'}>
        <Text fontWeight={'semibold'} fontSize={'16px'}>
          Update duration remaining
        </Text>
        <UpdateTimeInput jobId={jobId || ''} />
      </Flex>
    );
  } else {
    return (
      <Text
        fontWeight={'medium'}
        fontSize={'smaller'}
        color={getColor('fg.muted')}
        path="platform:missionControl.updateDurationMessage"
      />
    );
  }
}
